import Button from "heroic-ui-library/dist/components/Button";
import { useState } from "react";
import toast from "react-hot-toast";
import Loading from "react-loading";

import { apiClient } from "../../api/api-client";

import OTPVerify from "./OTPVerify";
import { getCountryCode } from "../../lib";
import PINField from "./PINField";

type Props = { onLogin: () => void };

export default function CreateAccountUsingPhone({ onLogin }: Props) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState(
    getCountryCode() == "US" ? "+1" : "+91"
  );
  const [pinCode, setPinCode] = useState("");
  const [confirmPin, setConfirmPinCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [path, setPath] = useState<"otpVerification" | "createPIN">(
    "otpVerification"
  );

  const createPin = async () => {
    if (pinCode != confirmPin) {
      return toast.error("Pin does not match");
    }

    setIsLoading(true);

    try {
      const response = await apiClient.createParentAccount(
        countryCode + phoneNumber.replace(/\D/g, "")
      );
      await apiClient.setParentPIN(pinCode, response.parent_code);
      onLogin();
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }

    setIsLoading(false);
  };

  return (
    <div className="space-y-4 mt-4 mb-4 flex flex-col">
      <h1 className="top-heading text-center mb-3">Create Account</h1>
      <div className="flex justify-center items-center mb-4">
        <div className="border-t-2 border-dotted border-gray-400 flex-1" />
        <div className="border-t-2 border-dotted border-gray-400 flex-1" />
      </div>
      {/* <span className="font-acme text-2xl text-left ">
        Enter your phone number. We will send an Pin on this number for
        verification.
      </span> */}
      {path == "otpVerification" && (
        <OTPVerify
          countryCode={countryCode}
          phoneNumber={phoneNumber}
          setCountryCode={setCountryCode}
          setPhoneNumber={setPhoneNumber}
          onVerificationSuccess={() => setPath("createPIN")}
        />
      )}
      {path == "createPIN" && (
        <>
          <PINField pinCode={pinCode} setPinCode={setPinCode} />
          <PINField
            placeholder="Confirm PIN"
            className="text-lg w-full"
            pinCode={confirmPin}
            setPinCode={setConfirmPinCode}
          />

          {!isLoading && (
            <Button
              onClick={createPin}
              btnType="green"
              className="submit-btn"
              label={"Create PIN"}
            />
          )}
          {isLoading && (
            <div className="w-full items-center justify-center flex">
              <Loading color="#002356" type="spin" />
            </div>
          )}
        </>
      )}
      <span className="text-2xl font-acme">
        Already have an account?{" "}
        <span
          onClick={onLogin}
          className="text-blue-600 underline cursor-pointer"
        >
          Click here
        </span>
      </span>
    </div>
  );
}
